// extracted by mini-css-extract-plugin
export default {"actions":"Packs_actions__DKyxe","link":"Packs_link__i4I66"};